import { render } from "./feedback.vue?vue&type=template&id=7c7e1a2c&scoped=true&ts=true"
import script from "./feedback.vue?vue&type=script&lang=ts"
export * from "./feedback.vue?vue&type=script&lang=ts"

import "./feedback.vue?vue&type=style&index=0&id=7c7e1a2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c7e1a2c"]])

export default __exports__